import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { offer } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-espresso-line bg-espresso-2 px-5 py-14 text-center" data-id="element-78" data-mp="vhajid21if0t">
      <Reveal data-id="element-79" data-mp="19cun81976qnn">
        <h2 className="font-display text-[36px] uppercase leading-[0.98] text-ivory" data-id="element-80" data-mp="19cmdujcaa3h7">
          La tua prossima lezione può essere
          <span className="block text-wood" data-id="element-81" data-mp="1jcd6sgl74af6">pronta già stasera</span>
        </h2>
        <p className="mt-5 font-serif text-[17px] italic leading-relaxed text-sand" data-id="element-82" data-mp="1eebm5r84g31l">
          Il libro con guida e 50 esercizi, {offer.bonusCount} bonus in regalo e un sistema chiaro per ogni lezione. Tutto in
          PDF, subito nella tua email.
        </p>
        <CtaButton className="mt-8" data-id="element-83" data-mp="1o4n1e9x99yns">Voglio il pack completo — {offer.price}</CtaButton>
        <p className="mt-3 text-[13px] text-sand" data-id="element-84" data-mp="2245xg4csljjq">
          Pagamento unico · Garanzia di {offer.guaranteeDays} giorni
        </p>
      </Reveal>
    </section>;
}